
let concat = "<br />";

const aboutkb = {
    "About KrazyBee": [
        {
          question: "What is the business of KrazyBee Services Private Limited (KrazyBee)?",
          answer: "KrazyBee Services Private Limited is a Non-Deposit taking Non-Banking Financial Institution (NBFC) registered with RBI." + concat + concat +
                  "The company commenced operations in fiscal 2017 and is promoted by Mr Madhusudan Ekambaram, Mr Vivek Veda and Mr Karthikeyan Krishnaswamy, who have prior experience in product portfolio management, sales, technology and finance." + concat + concat +
                  "The company offers unsecured personal loans to young professionals, with ticket size varying up to Rs 4 lakh with average tenure of around eight months. It offers loans through its group company, Finnovation Tech Solutions Private Limited (FTSPL), which has a tech platform, ‘KreditBee’ and the platform originates loans for KrazyBee and several other partner - lenders." + concat + concat +
                  "The group has an in-house technological base with end-to-end integration for loan origination, risk assessment, collections, accounting. Owing to its digital origination method, the group has a sphere of lending across India."
        },
        {
          question: "Who are the investors in KrazyBee?",
          answer: "KrazyBee is backed by strong PE investors such as Premji Invest, Advent International, MUFG Bank, TPG NewQuest Capital, Motilal Oswal Private Equity, ICICI Bank amongst others."
        },
        {
          question: "What are the strengths of KrazyBee?",
          answer: "<ul><li>Strong Investors – Advent International, MUFG Bank, TPG NewQuest Capital, Motilal Oswal Private Equity, ICICI Bank" + concat +
                  "<li>Healthy Capitalization – The Capital Adequacy Ratio (CRAR) is 45.6% which is significantly higher than RBI minimum limit of 15%" + concat +
                  "<li>Strong Asset Quality - The company has a low GNPA of 2.19% and NNPA of 0.77% as on 30th Sep’23." + concat +
                  "<li>Profitable - The company has posted a Profit After Tax of Rs. 65 Cr in FY23 and Rs. 71 Cr in H1FY24." + concat +
                  "<li>Diversified Borrowing - Well-diversified borrowing profile with lenders including Public/ Private Sector Banks like SBI, Federal Bank, Indusind Bank, etc., and NBFCs."
        },
        {
          question: "What are the major risks to KrazyBee?",
          answer: "- Moderate Borrower profile – KrazyBee caters to the MSME segment, which is highly vulnerable to downturns in economic cycles. Further, its entire AUM represents unsecured lending."
          
        },
        {
          question: "What is the Credit rating for KrazyBee?",
          answer: "KrazyBee has been upgraded from CRISIL BBB+ in Sept’23 and is now rated ‘CRISIL A-/ Stable’."
        },
        {
          question: "What is the AUM of KrazyBee?",
          answer: "The overall AUM as on 30th Sep’23 is Rs. 6,005 Cr. of which Own lending comprised of Rs. 3,531 Cr. and co-lending comprised of Rs. 2,474 Cr."
        },
        {
          question: "What is the profitability of KrazyBee?",
          answer: "The company has posted a Profit After Tax of Rs. 65 Cr in FY23 and Rs. 71 Cr in H1FY24."
        },
        {
          question: "How is the asset quality of KrazyBee?",
          answer: "The company has a low GNPA of 2.19% and NNPA of 0.77% as on 30th Sep’23."
        },
        {
          question: "What is the Capital Adequacy ratio?",
          answer: "The Capital Adequacy Ratio (CRAR) as on 30th Sep’23 is 45.6%."
        },
    ],
  }
  
  export default aboutkb;